import React from 'react';
import Link from '@/lib/Link';
import * as styles from './contactButton.module.scss';
import icPivotFlagHover from './img/ic_pivot_flag_hover.avif';

const ContactButton: React.FC = () => {
  return (
    <div className={styles.contactButton}>
      <Link to="https://pivot.jp/contact" target="_blank">
        <img
          className={styles.contactButton__img_hover}
          src={icPivotFlagHover}
          alt="ic-pivot-flag"
        />
        <div className={styles.contactButton__img_preloadUp}></div>
        <div className={styles.contactButton__img_preloadDown}></div>
        <div className={styles.contactButton__inner}>
          <div className={`${styles.contactButton__img} ${styles.contactButton__imgUp}`}></div>
          <div className={`${styles.contactButton__img} ${styles.contactButton__imgDown}`}></div>
        </div>
      </Link>
    </div>
  );
};

export default ContactButton;
